<template>
    <div ref="mainHigh" class="mianLogin">
        <div class="logoTop">
            <h3>高企助手</h3>
        </div>
        <div class="userinfo">
            <!-- <img width="100%" src="@/assets/img/userPhoto.jpg" alt=""> -->
            <div>
                <h4>{{contactName}}</h4>
                <p>{{companyName}}</p>
            </div>
            <span class="fixPass">
                <!-- <span v-if="logoState" @click="goMore('/webHighEnterpriseEvaluation/fixPass')">修改信息</span>
                <span v-else @click="goMore('/webHighEnterpriseEvaluation/loginWx')">立即登录</span>    -->
                <span @click="clearCl">安全退出</span>
            </span>
        </div>
        <div class="input-groud">
            <ul>
                <Li @click="goMore('/webHighEnterpriseEvaluation/list')"><ContainerOutlined /> 我的测评<RightOutlined class="fr" /></Li>
            </ul>
        </div>
    </div>
  </template>

  <script>
  import { basicsEvaluateUsers } from "@/api/webHighEnterpriseEvaluation";
  import {ls} from "@/utils/util";
  import axios from "axios";
  import {notification} from "ant-design-vue";
  export default {

    data () {
        return {
            logoState:false,
            contactName:null,
            companyName:null,

        }
    },
    mounted() {
        if(this.$route.query.loginStatus==1){
            this.logoState = true
        }

        if(ls.get('wxLoginPhone')){
            this.logoState = true
            this.getcheckUser(ls.get('wxLoginPhone'))
        }else{
            this.goMore('/webHighEnterpriseEvaluation/login')
        }
      this.$refs.mainHigh.style.height = window.innerHeight+'px'
    },
    methods: {
        clearCl(){
            ls.clear();
            this.$router.go()
        },
        getcheckUser(phone) {
           /* this.getAction({
                url: basicsEvaluateUsers.checkUser,
                params:{
                    contactPhone:phone
                }
            }
            ).then((res) => {
                if(res.id){
                    this.contactName = res.contactName
                    this.companyName = res.companyName
                }else{
                    alert('用户未注册！')
                }

            })*/
          this.getAxios('get', basicsEvaluateUsers.checkUser, {
            contactPhone:phone
          }, (res) => {
            if(res.data.data.id){
              this.contactName = res.data.data.contactName
              this.companyName = res.data.data.companyName
            }else{
              alert('用户未注册！')
            }
          })
        },
      getAxios(method, url, params, fun) {
        axios({
          method: method,
          headers: {
            AuthenticationPhone: ls.get('jwtphone'),
            AuthenticationJwt: ls.get('jwtMain')
          },
          url: url,
          params: params
        }).then(res => {
          if (res) {
            fun(res)
          }
        }).catch(() => {
          this.visible = false
          notification.warning({
            message: '登录过期',
            style: {
              width: '400px',
              fontWeight: '600',
              marginLeft: `${-200}%`,
              marginTop: `${20}%`,
            }
          });
          this.modalShowType = null
          setTimeout(() => {
            this.visible = true
          }, 50);
        })
      },
        //路由跳转
        goMore(url, str) {
            if(str){
                this.$router.push({ path: url, query: { id: str } })
            }else{
                this.$router.push(url)
            }
        },
    }
  };
  </script>
  <style lang="less" scoped>
  .mianLogin{
    font-family: '微软雅黑';
    width:100%;
    background: url(../img/bg.jpg) no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .logoTop{
        margin-top:1rem;
        margin-bottom:2rem;
    }
    .userinfo{
        width:90vw;
        min-height:3rem;
        margin-bottom: 1rem;
        display: flex;
        position: relative;
        img{
            width:4.5rem;
            height:4.5rem;
            border-radius: 4.5rem;
        }
        div{
            flex:1;
            padding:.8rem;
        }
        .fixPass{
            position: absolute;
            right:-5vw;
            display: block;
            top:1rem;
            font-size: 1rem;
            background: #1c4ff7;
            color:#fff;
            padding:.4rem 1.2rem .5rem 1.2rem;
            border-radius: 3rem 0 0 3rem;
        }
    }
    .input-groud{
        display: flex;
        flex-direction: column;
        width:90vw;
        overflow: auto;
        padding:.5rem 1rem 1rem 1rem;
        background: #fff;
        position: relative;
        border-radius: .4rem;
        li{
            font-size: 1rem;
            padding: .5rem 0;
            border-bottom: .1rem solid #f1f1f1;
        }
        .fr{
            float: right;
            margin-top:.3rem;
        }
        .captchaCode{
            position:absolute;
            right:1rem;
            bottom:1.2rem;
            z-index: 999;
        }
        input{
            flex:1;
            font-size: 1rem;
            color:#3d3d3d;
            padding:.5rem;
            &:focus{
                border-style: none;
                outline: none;
            }
            border:0;
            height:3rem
        }
    }
    .subtn{
        width:90vw;
        margin-top:2rem;
        text-align: center;
    }
  }
  </style>
